import React from "react";
import { organizationTeamDashboard } from "../../../../services/organizationService";
import { useOutletContext } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { t } from "i18next";

const PromoterSettlement = () => {
  const { promoter, selectedLanguage } = useOutletContext();

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["promoter-dashboard", promoter?.data?.eventData?._id],
    queryFn: async () => {
      const res = await organizationTeamDashboard({
        event: promoter?.data?.eventData?._id,
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.data;
    },
    enabled: !!promoter?.data?.eventData?._id,
  });

  return (
    <div className="w-full p-6 bg-white">
      {/* Header */}
      <h1 className="text-2xl lg:text-4xl font-bold text-black mb-10">{t("Settlement")}</h1>

      {/* Online Sales Section */}
      <div className="mb-16">
        <h2 className="text-2xl font-bold text-black mb-3">{t("Sales")}</h2>
        <p className="text-gray-500 text-sm font-medium mb-8 leading-relaxed">
          {t(
            "These are the sales that the promoter has made through the dancebrite website using their promotional code"
          )}
        </p>

        {/* Sales Stats Grid */}
        <div className="bg-gray-50 rounded-none p-4 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 md:divide-x gap-2 divide-gray-300">
            {/* Amount Sold */}
            <div className="text-start md:text-center pr-8">
              <h3 className="text-sm text-gray-600 mb-3 font-medium">
                {t("Total Successful Order")}
              </h3>
              <div className="text-3xl md:text-5xl font-bold text-black mb-2">
                {data?.totalPromoterOrder}
              </div>
            </div>

            {/* Generated Commissions */}
            <div className="text-start md:text-center md:px-8">
              <h3 className="text-sm text-gray-600 mb-3 font-medium">
                {t("Generated Commissions")}
              </h3>
              <div className="text-3xl md:text-5xl font-bold text-black">
                {data?.totalPromoterFee} $
              </div>
            </div>

            {/* To Receive */}
            {/* <div className="text-center pl-8">
              <h3 className="text-sm text-gray-600 mb-3 font-medium">
                To Receive
              </h3>
              <div className="text-5xl font-bold text-black">0.00 €</div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoterSettlement;
